import { Component, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { IDetails } from './model/IDetails';
import { TranslateService } from '@ngx-translate/core';
import { MobileDetectionService } from '../../services/mobile-detection.service';
import { environment } from '../../../../environments/environment';
import { NewPrintFormatsComponent } from '../new-print-formats/new-print-formats.component';
import { PrintFormatsNewComponent } from '../../../print-formats-new/print-formats-new.component';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TruckLoadViewComponent } from '../truck-load-view/truck-load-view.component';
import { ChangeTranporterDriverHistoryComponent } from '../change-tranporter-driver-history/change-tranporter-driver-history.component';
import { PrintFormatsComponent } from '../../../print-formats/print-formats.component';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
@Component({
  selector: 'app-details-card',
  templateUrl: './details-card.component.html',
  styleUrls: ['./details-card.component.scss']
})
export class DetailsCardComponent implements OnInit {
  selectedRowIndex: number;
  @Input() selectedRowId: number = 0;
  @Output() goToDetails = new EventEmitter<string>();
  @Input() data: any;
  @Input() IsFTLShow: boolean = false;
  @Input() cardDetails: IDetails;
  @Input() isTableCardView: any;
  @Output() onActionClickOutput = new EventEmitter<any>();
  @Input() isDiffTablePattern: any;
  @Input() noOfColumnToShowOnModile: any;
  isMobileView: any;
  @Output() GoToDetailsCard = new EventEmitter<any>();
  @Input() isActive: boolean = false;
  @Output() onShipNowContract = new EventEmitter<any>();

  @Input() isShowCreatedTime: boolean = false;
  @Input() isPrintDropDownShow: boolean = false;
  @Input() isShowTravelKm: boolean = false;
  @Input() isShowTravelTime: boolean = false;
  showHeader: boolean = false;
  @Input() showPickupPercentageOnHeader: boolean = false;
  @Input() showDeliverPercentageOnHeader: boolean = false;
  @Input() showEmptyPickPercentageOnHeader: boolean = false;
  @Input() showCardName: boolean = true;
  @Input() isTripView: boolean = false;
  @Input() isViewTripBtn: boolean = false;
  @Output() onPageNumberChnge = new EventEmitter<any>();
  @Output() onPageChnge = new EventEmitter<any>();
  // isDropdownOpen = false;
  @Input() PrintNameList: any;
  @Input() cardIndex: number;
  static activeDropdownIndex: number | null = null;

  @Output() PrintDropdownSelecteData = new EventEmitter<any>();
  @ViewChild(NewPrintFormatsComponent) NewPrintFormatsChild: NewPrintFormatsComponent;
  @ViewChild(PrintFormatsNewComponent) PrintFormatsNewComponent: PrintFormatsNewComponent;
  // @ViewChild(TruckLoadViewComponent) TruckLoadViewComponent: TruckLoadViewComponent;
  @Output() ViewTripAction = new EventEmitter<any>();
  @Output() GenerateInvoiceAction = new EventEmitter<any>();
  @Output() changeDriverTransporterModal = new EventEmitter<any>();
  @Output() showAllPackagesModal = new EventEmitter<any>();
  @Input() ScreenType: any;
  @Input() navigateBackId: any;
  apiUrl: any = environment.apiUrl;
  imgUrlTransporter: any = '../../../../assets/company/company-icon.svg'
  //added by vithu 21-03-2025
  showcomponent: boolean = false;
  @Input() GSTType: any;
  @Input() THCId: any;
  @Input() TransporterId: any;
  @Input() BookingId: any;
  @Input() TransporterName: any;
  @Input() ConsignmentDetailId: any;
  @Input() CustomerId: any;
  @Input() IsConsignmentWise: boolean = false;
  @Input() ConsignmentNo: any;
  @Input() OrderNo: any;
  @Input() IndentId: any;
  @Input() ConsignmentNoteDetailId: any;
  VehicleType: any; // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)
  cardVehicleType: any; // Added by priya - 09/06/2026 - cn(PRIYA-JUN26-002)

  @Output() PODmodalPass = new EventEmitter<any>();

  @Input() StagesArray: any[] = [];
  @Input() cardGroupTitle: string;
  @Output() goToDetailsPage = new EventEmitter<string>();
   @Input() selectedDropdownIndex: number;
  @Output() onDropdownOpen = new EventEmitter<number>();
  DropdowmType: any;
  @Output() onTripActionClickOutput = new EventEmitter<any>();
  @ViewChild(PrintFormatsComponent) PrintFormatsChild: PrintFormatsComponent;
  userId: any;
  CompanyId: any;
  EwayBillFiling: boolean = false;
  @Output() onActionClickBidRequest = new EventEmitter<any>();  //added by fahim 02-02-2026 :)

  ExchangeRate: any = {
    lable: "Exchange Rate",
    formControlName: "ExchangeRate",
    dataField: "ExchangeRate",
    placeholder: "Enter Exchange Rate",
    type: "number",
    isReadOnly:true
  };
  @Output() sendExchangeRate = new EventEmitter<any>();  //added by fahim 02-02-2026 :)
  @Output() onTableActionClickOutput = new EventEmitter<any>();
  @Output() emitTableSelectedRow = new EventEmitter<any>();
  ExchangeRateVal:any;
  @Input() MakeToOrderAutoGeneratePO: boolean = false;
  @Input() showUpdateTrackingLink: boolean = false;//added by BURHAN - 27-May-2026
  @Output() onUpdateTrackingClick = new EventEmitter<any>();//added by BURHAN - 27-May-2026
  
  constructor(
    private translate: TranslateService,
    private mobileDetectionService: MobileDetectionService,
    private router: Router,
    private modalService: NgbModal,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
  ) { }
  ngOnInit(): void {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    !this.selectedRowId ? this.selectedRowIndex = 0 : null;
    // Added by priya - 28/01/2026 - getting eway bill system setting value from local storage - cn(PRIYA-JAN26-014)
    let ewayBillSystemSetting = localStorage.getItem("EwayBillFiling")
    this.EwayBillFiling = ewayBillSystemSetting == '1' ? true : false;
    // End by priya
    setTimeout(() => {
      if (this.cardDetails.cartType == 'Role') {
        document.getElementById("card_body").classList.remove("h-100");
      }
    }, 1000);
  }

  gotToPage() {

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  openPhoneHyperLink(phone: any) {
    const phoneLink = "tel:+" + phone;
    window.location.href = phoneLink;
  }

  openEmailHyperLink(email: any) {
    const phoneLink = "mailto:+" + email;
    window.location.href = phoneLink;
  }

  onActionClick(row, event,) {
    console.log('onclick button', row, event)
    this.onActionClickOutput.emit(event);
    return;
  }

  onTripActionClick(row, event) {
    console.log('onclick button', row, event)
    // added by yash 23/04/2026
    let PrintName: string;
    if (typeof event === 'string'){
      PrintName = event;
    }
    else if (event && event.event && event.event.target && event.event.target.innerText) {
      PrintName = event.event.target.innerText;
    }
    else if (event && event.target && event.target.innerText) {
      PrintName = event.target.innerText;
    }
    else {
      PrintName = event;
    }
    // end by yash 23/04/2026
    //let PrintName = event.target.innerText ? event.target.innerText : event; // comment by yash
    if (PrintName === 'Trip Expense') {
      this.VehicleType = row.VehicleTypeId; // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
      this.cardVehicleType = row.cardVehicleType; // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
      this.modalRef = this.modalService.open(this.tripExpense, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
    } else if (PrintName == 'Record Income') {
      this.modalRefRI = this.modalService.open(this.recordIncome, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
    } else if(PrintName == 'Print Quote'){
      this.PrintQuote(row.Id);
    } else {
      // this.PrintFormatsNewComponent.PrintDropdownSelecteData(item, row);
      // DetailsCardComponent.activeDropdownIndex = null;
      // this.PODmodalPass.emit({ item, row })
      this.onTripActionClickOutput.emit({event: event,row: row}); // added by yash 23/04/2026
      this.PrintFormatsNewComponent.PrintDropdownData(PrintName, row);
      DetailsCardComponent.activeDropdownIndex = null;
    }
  }

  getCurruncyValue = (value: number): string => {
    if (value) {
      return (this.cardDetails.currencySymbol ? this.cardDetails.currencySymbol : "") + (value).toLocaleString('en-US');
    }
    return "";
  }
  onGoToClick(row: any) {
    this.goToDetails.emit(row);
    this.selectedRowIndex = null;
  }
  OnGoToDetailsCard(row, event,) {
    if(row && row.ValueType === 'BidRequestRateBreakup'){  //added by fahim 02-02-2026 :)
      console.log('OnGoToDetailsCard',row);
    }else{
      this.GoToDetailsCard.emit(event);
    }
  }

  OnGoToDetails(event,) {
    this.goToDetailsPage.emit(event);
  }

  tempActionList: any = [];
  getActionList(data, list: any[] = [...this.cardDetails.footer.actionList]): void {
    const filteredList = list.filter((x) => {
      // Keep items where dataField doesn't exist or its value is true
      return x.dataFieldName ? data[x.dataFieldName] === true : true;
    });
    this.tempActionList = [...filteredList];

    for (const item of this.tempActionList) {
      if (window.location.pathname == "/GoodsInward") {
        item.disabled = false;
        // if (item.label == 'Putaway slip' && data.isOrderConfirm) {
        //   item.disabled = true;
        // }
        if (item.label == 'GRN slip' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Download Putaway' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Upload Putaway' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/so_GoodsOutward" || window.location.pathname == "/so_GoodsOutward/view/" + data.Id) {
        item.disabled = false;
        if (item.label == 'Send for E-Invoice' && (!data.isOrderConfirm || data.IsEInvoiceDone || data.OutwardType == 'po_rtn_PurchaseOrder')) {
          item.disabled = true;
        }
        if (item.label == 'Print Invoice' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        // if (item.label == 'Pick Slip' && data.isOrderConfirm) {
        //   item.disabled = true;
        // }
        // if (item.label == 'Packing List' && data.isOrderConfirm) {
        //   item.disabled = true;
        // }
        if (item.label == 'Download Outward' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Upload Outward' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/so_Orders") {
        item.disabled = false;
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Cancel Order' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Generate Outward' && !data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/NewPurchaseOrder") {
        item.disabled = false;
        if (item.label == 'Generate Inward' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Generate Inward' && data.POStatus == 'Partial Cancel' && data.POStatus == 'Full Cancel') {
          item.disabled = true;
        }
        if (item.label == 'Approve GRN MRP Difference' && data.orderStatus != 'Order Reshuffled Pending') {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Cancel Order' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Cancel Order' && data.POStatus == 'Partial Cancel' && data.POStatus == 'Full Cancel') {
          item.disabled = true;
        }
        if (item.label == 'Confirm Order' && data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Confirm Order' && data.POStatus == 'Partial Cancel' && data.POStatus == 'Full Cancel') {
          item.disabled = true;
        }
      }
      if (window.location.pathname == "/so_StockTransfer" || window.location.pathname == "/so_StockTransfer/view/" + data.Id) {
        item.disabled = false;
        if (item.label == 'Generate Outward' && !data.isOrderConfirm) {
          item.disabled = true;
        }
        if (item.label == 'Delete' && data.isOrderConfirm) {
          item.disabled = true;
        }
      }
      const segments = window.location.pathname.split('/');
      if (window.location.pathname == "/order_LTL" || segments[1] == 'order_LTL') {
        item.disabled = false;
        // if (item.label == 'Print Invoice' && data.InvoiceNo == null) {
        //   item.disabled = true;
        // }
        if (item.label == 'Generate EInvoice' && data.IsEInvoiceGenerate != 'NO') {
          item.disabled = true;
        }
        if (item.label == 'Generate EWayBill' && (data.BookingId == null || data.eWayBillNo != null)) {
          item.disabled = true;
        }
        if (item.label == 'Confirm Delivery' && (data.ConsignmentDetailId == null || data.OrderTripStatus != 'Loaded')) {
          item.disabled = true;
        }
        if (item.label == 'Download EWayBill' && (data.EwayBillDocURL == null)) {
          item.disabled = true;
        }
        if (item.label == 'Attachments' && (data.ConsignmentDetailId == null)) {
          item.disabled = true;
        }
      }
      // Added by priya - 11/02/2026 - cn(PRIYA-FEB26-002)
      if (window.location.pathname == "/EwayBillLogDetail") {
        item.disabled = false;
        if (data.EwayBillNo !== ''){
          if (item.label == 'Generate Part B' && data.IsEwayPartBFiled == 'Filed') {
            item.disabled = true;
          }
          if (item.label == 'Update EwayBill' && data.IsEwayPartBFiled !== 'Filed') {
            item.disabled = true;
          }
          if (item.label == 'Extend EwayBill' && data.IsEwayBillExtended == 'Extended') {
            item.disabled = true;
          }
          if (item.label == 'Print EwayBill' && !data.EwayBillNo) {
            item.disabled = true;
          }
        } else {
          item.disabled = true;
        }
      }
    }
  }

  get filteredActionList(): any[] {
    return this.tempActionList.filter(item => !item.disabled) || [];
  }

  onShipNowClick(data) {
    this.onShipNowContract.emit(data);
  }


  onCheckBoxClick(event, row, index, dataField) {


    var type: any = 'CheckBox';
    // this.selectedRow.emit({ event, row, index, type });

    console.log("Row Selected:", row);
  }

  onPageNumberChange(event) {
    this.onPageNumberChnge.emit(event);
  }

  onPageChange(event) {
    this.onPageChnge.emit(event);
  }

  get isDropdownOpen(): boolean {
    return DetailsCardComponent.activeDropdownIndex === this.cardIndex;
  }

  toggleDropdown() {
    if (DetailsCardComponent.activeDropdownIndex === this.cardIndex) {
      DetailsCardComponent.activeDropdownIndex = null; // Close dropdown
    } else {
      DetailsCardComponent.activeDropdownIndex = this.cardIndex; // Open clicked dropdown
    }
  }

  onSelectItem(item: any, row: any) {
    if (item.PrintName === 'Trip Expense') {
      this.modalRef = this.modalService.open(this.tripExpense, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
      this.VehicleType = row.VehicleTypeId; // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
      this.cardVehicleType = row.cardVehicleType; // Added by priya - 10/06/2026 - cn(PRIYA-JUN26-002)
    } else if (item.PrintName == 'Record Income') {
      this.modalRefRI = this.modalService.open(this.recordIncome, { centered: true, size: "lg", windowClass: "modal-xl-custom" });
    } else {
      // this.PrintFormatsNewComponent.PrintDropdownSelecteData(item, row);
      // DetailsCardComponent.activeDropdownIndex = null;
      this.PODmodalPass.emit({ item, row })
      this.PrintFormatsNewComponent.PrintDropdownSelecteData(item, row);
      DetailsCardComponent.activeDropdownIndex = null;
    }
    // this.isDropdownOpen = false; // Close dropdown after selection
  }

  navigateToVehicle(Id) {
    if (Id) {
      let Url = '';

      if (this.ScreenType == 'FTL') {
        Url = 'FtlList/view/' + this.navigateBackId + '?type=' + this.ScreenType + '&searchValue=';
      } else if (this.ScreenType == 'ContainerMovement') {
        Url = 'Container-Movement/view/' + this.navigateBackId + '?type=' + this.ScreenType + '&searchValue=';
      }
      localStorage.setItem('previousPageUrl', Url);

      this.router.navigateByUrl(`/NewVehicleMaster/view/${Id}`);
      // window.open(`/NewVehicleMaster/view/${Id}`, '_blank');
    } else {
      console.error('Vehicle ID is undefined');
    }
  }

  navigateToDriver(Id) {
    if (Id) {
      let Url = '';

      if (this.ScreenType == 'FTL') {
        Url = 'FtlList/view/' + this.navigateBackId + '?type=' + this.ScreenType + '&searchValue=';
      } else if (this.ScreenType == 'ContainerMovement') {
        Url = 'Container-Movement/view/' + this.navigateBackId + '?type=' + this.ScreenType + '&searchValue=';
      }
      localStorage.setItem('previousPageUrl', Url);

      this.router.navigateByUrl(`/NewDriver/view/${Id}`);
      // window.open(`/NewVehicleMaster/view/${Id}`, '_blank');
    } else {
      console.error('Vehicle ID is undefined');
    }
  }

  navigateToDriverDetail(Id){
    if (Id) {
      let Url = '';

      if (this.ScreenType == 'FTL') {
        Url = 'FtlList/view/' + this.navigateBackId + '?type=' + this.ScreenType + '&searchValue=';
      } else if (this.ScreenType == 'ContainerMovement') {
        Url = 'Container-Movement/view/' + this.navigateBackId + '?type=' + this.ScreenType + '&searchValue=';
      }
      localStorage.setItem('previousPageUrl', Url);

      this.router.navigateByUrl(`/NewDriver/view/${Id}`);
      // window.open(`/NewVehicleMaster/view/${Id}`, '_blank');
    } else {
      console.error('Vehicle ID is undefined');
    }
  }

  navigateToTripDetail(Id) {
    if (Id) {
      let Url = '';

      if (this.ScreenType == 'FTL') {
        Url = 'FtlList/view/' + this.navigateBackId + '?type=' + this.ScreenType + '&searchValue=';
      } else if (this.ScreenType == 'ContainerMovement') {
        Url = 'Container-Movement/view/' + this.navigateBackId + '?type=' + this.ScreenType + '&searchValue=';
      }
      localStorage.setItem('previousPageUrl', Url);

      this.router.navigateByUrl(`/New-Trips/view/${Id}`);
      // window.open(`/NewVehicleMaster/view/${Id}`, '_blank');
    } else {
      console.error('Vehicle ID is undefined');
    }
  }

  OnViewTrip(data: any) {
    this.ViewTripAction.emit(data);
  }

  OnGenrateInvoice(data: any) {
    this.GenerateInvoiceAction.emit(data);
  }

  navigateToTransporter(Id) {
    if (Id) {
      let Url = '';

      if (this.ScreenType == 'FTL') {
        Url = 'FtlList/view/' + this.navigateBackId + '?type=' + this.ScreenType + '&searchValue=';
      } else if (this.ScreenType == 'ContainerMovement') {
        Url = 'Container-Movement/view/' + this.navigateBackId + '?type=' + this.ScreenType + '&searchValue=';
      }
      localStorage.setItem('previousPageUrl', Url);

      this.router.navigateByUrl(`/NewNetwork/view/${Id}`);
      // window.open(`/NewNetwork/view/${Id}`, '_blank');
    } else {
      console.error('TransporterId ID is undefined');
    }
  }

  openModalForTrips(event, type, BookingId) {
    console.log('changeDriverTransporterModal:', event, type);
    let payload: any = {};

    if (type === 'Transporter') {
      payload = { TransporterId: event, type, BookingId: BookingId };
    } else if (type === 'Driver') {
      payload = { DriverId: event, type, BookingId: BookingId };
    } else if (type === 'Vehicle') {
      payload = { VehicleId: event, type, BookingId: BookingId };
    }

    this.changeDriverTransporterModal.emit(payload);
  }

  modalRef: NgbModalRef | null = null;
  @ViewChild("tripExpense") tripExpense: TemplateRef<any>;
  closeModal() {
    this.modalRef.close();
  }

  modalRefRI: NgbModalRef | null = null;
  @ViewChild("recordIncome") recordIncome: TemplateRef<any>;
  closeModalRI() {
    this.modalRefRI.close();
  }

  showAllPackages(data) {
    this.showAllPackagesModal.emit({ show: true, data: data });
  }

  openChangeHistoryModal(data, type) {
    this.modalRef = this.modalService.open(ChangeTranporterDriverHistoryComponent, { centered: true, size: "lg" });
    this.modalRef.componentInstance.BookingId = data.BookingId;
    this.modalRef.componentInstance.HistoryType = type;
  }

  onGoToTripPage(Id) {

    localStorage.setItem('BackToFTLPageUrl', JSON.stringify({
      id: this.navigateBackId,
      type: this.ScreenType,
      searchValue: ''
    }));

    this.router.navigateByUrl(`/New-Trips/view/${Id}`);
  }

  getSplitItems(value: any): string[] {
    if (Array.isArray(value)) {
      return value;
    } else if (typeof value === 'string') {
      return value.split(',').map(function (v) { return v.trim(); });
    }
    return [];
  }

  addMilestone() {
  console.log('Add milestone clicked');
}

  isImportContainer(value: string): boolean {
    if (!value) return true; // or false depending on your logic
    return value.replace(/\s/g, '').toLowerCase() === 'importcontainer';
  }


getVehicleUtilizationPercent(TotalVehicleWeight: any, TotalTripProductWeight: any): string {
  const totalVehicleWeight = (TotalVehicleWeight !== null && TotalVehicleWeight !== undefined) ? TotalVehicleWeight : 0;
  const totalTripProductWeight = (TotalTripProductWeight !== null && TotalTripProductWeight !== undefined) ? TotalTripProductWeight : 0;

  if (totalVehicleWeight === 0) {
    return "0.00"; 
  }

  const percent = (totalTripProductWeight / totalVehicleWeight) * 100;
  return percent.toFixed(2);
}

getVehicleCBMUtilizationPercent(vehicleCBM: any, TotalProductCBM: any): string {
  const totalVehicleCBM = (vehicleCBM !== null && vehicleCBM !== undefined) ? vehicleCBM : 0;
  const totalTripProductCBM = (TotalProductCBM !== null && TotalProductCBM !== undefined) ? TotalProductCBM : 0;

  if (totalVehicleCBM === 0) {
    return "0.00"; 
  }

  const percent = (totalTripProductCBM / totalVehicleCBM) * 100;
  return percent.toFixed(2);
}

  getTransportLabel(service: string, type: 'first' | 'middle' | 'last'): string {
    if (!service) return '';

    const normalized = service.replace(/\s/g, '').toLowerCase();

    if (normalized === 'importcontainer') {
      switch (type) {
        case 'first': return 'CFS/Port';
        case 'middle': return 'De-Stuff At';
        case 'last': return 'Return';
      }
    } else if (normalized === 'exportcontainer') {
      switch (type) {
        case 'first': return 'Empty Yard';
        case 'middle': return 'Stuffing At';
        case 'last': return 'CFS/Port';
      }
    } else {
      // fallback case
      switch (type) {
        case 'first': return 'CFS';
        case 'middle': return 'Origin';
        case 'last': return 'Destination';
      }
    }

    return '';
  }

  get TripDropdownType() {
    let type = this.ScreenType.toLowerCase();
    if (type === 'ftl') return 'FtlTripActions';
    if (type === 'containermovement') return 'FtlContainerTripActions';
    if (type === 'ltl') return 'FtlLTLTripActions';
    return 'FtlTripActions';
  }

  get ListDropdownType() {
    let type = this.ScreenType.toLowerCase();
    if (type === 'ftl') return 'FtlList';
    if (type === 'containermovement') return 'FtlContainerList';
    if (type === 'ltl') return 'LTLList';
    return 'FtlList';
  }

   PrintQuote(Id) {
    this.PrintFormatsChild.OrderId = Id;
    this.PrintFormatsChild.InvoiceType = 'NewPrintQuote';
    this.PrintFormatsChild.UserId = this.userId;
    this.PrintFormatsChild.CompId = this.CompanyId;
    this.PrintFormatsChild.PrintInvoice();
  }

  onActionClickBidRequests(event,row){  //added by fahim 02-02-2026 :)
    this.onActionClickBidRequest.emit({event,row});
  }

  getChangedValueForCurrency(value,Field, data,){
    let val = 0;
    this.ExchangeRateVal=0;
    if (value) {
      val = Number(value);
      this.ExchangeRateVal=val;
      data = val;
    }
    console.log(data);
  }

  onTableActionClick(event,) {
    this.onTableActionClickOutput.emit(event);
  }

  onCheckSelect(event,) {
    this.emitTableSelectedRow.emit(event);
  }

  isExchangeRateEdit = false;
  enableRateEdit() {
    this.isExchangeRateEdit = true;
    this.ExchangeRate.isReadOnly=false;
  }

  cancelRateEdit() {
    this.ExchangeRate.isReadOnly=true;
    this.isExchangeRateEdit = false;
  }

  saveRate() {
    this.sendExchangeRate.emit(this.ExchangeRateVal);
    this.ExchangeRate.isReadOnly=true;
    this.isExchangeRateEdit = false;
  }
  //added by BURHAN - 27-May-2026
  updateTracking() {
    console.log('calling')
    this.onUpdateTrackingClick.emit(this.data);
  }
  //end by BURHAN
}
